import React, { ReactNode } from 'react';

import debug from '@fastlessjs/backoffice-layer/dist/utils/debug';
import { Alert, Card, List, Modal } from 'antd';

import { t } from '../../config/translations';
import {
  ArticleType,
  ReturnReason,
  returnDisclaimerContent,
} from '../utils/returnDisclaimerContent';

// Register this component for debug tracking
debug.registerComponent('ReturnDisclaimer');

type ReturnDisclaimerProps = {
  articleType: ArticleType;
  returnReason: ReturnReason;
  isModalOpen: boolean;
  handleOk: () => void;
  handleCancel: () => void;
};

const ReturnDisclaimer = (props: ReturnDisclaimerProps) => {
  debug.trackRender('ReturnDisclaimer');
  const { articleType, returnReason, isModalOpen, handleOk, handleCancel } = props;
  debug.log(
    'ReturnDisclaimer',
    `Rendering with articleType: ${articleType}, returnReason: ${returnReason}`,
  );
  const data = returnDisclaimerContent(articleType, returnReason);

  return (
    <Modal
      title={
        <Alert
          message={t('modal.attention')}
          description={t('modal.optimizeChoice')}
          type="warning"
          showIcon
        />
      }
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      width="50%"
      closable={false}
      okText={t('button.validateReturn')}
      cancelText={t('button.cancel')}
    >
      <List
        grid={{ column: 1 }}
        dataSource={data?.advice as Record<string, ReactNode>[]}
        renderItem={(item: Record<string, ReactNode>) => (
          <List.Item>
            {Object.entries(item).map(([key, value]) => (
              <Card key={Math.random()} title={key}>
                {value as ReactNode}
              </Card>
            ))}
          </List.Item>
        )}
      />
    </Modal>
  );
};

export { ReturnDisclaimer };

// Mark this component as initialized
debug.markInitialized('ReturnDisclaimer');
